import React, {
  SelectHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { Flex } from '@chakra-ui/react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import { FiAlertCircle } from 'react-icons/fi';

import { Container, Select, Option, Error } from './styles';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  containerStyle?: object;
  options: CanalDATA[];
  placeholder: string;
}
interface CanalDATA {
  codcam: number;
  nomcam: string;
}

const InputSelectMktCanal: React.FC<SelectProps> = ({
  name,
  icon: Icon,
  options,
  placeholder,
  containerStyle,
  ...rest
}) => {
  const inputRef = useRef<HTMLSelectElement>(null);
	const iconRef = useRef<any>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isField, setIsField] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsField(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField, defaultValue]);

  return (
    <Container
      isErrored={!!error}
      isField={isField}
      isFocused={isFocused}
      style={containerStyle}
    >
      {Icon && <Icon />}
      <Select
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
        placeHolder={!!inputRef.current?.value}
      >
        <Option value="" disabled>
          {placeholder}
        </Option>

        {options.map((item, indice) => (
          <Option key={indice} value={item.codcam}>
            {item.nomcam}
          </Option>
        ))}
      </Select>

      {error && (
				<Error title={error}>
					<Flex pr={1} ref={iconRef}>
						<FiAlertCircle color="#c53030" size={20} />
					</Flex>
				</Error>
      )}
    </Container>
  );
};

export default InputSelectMktCanal;
